import {
  getGlobalParamsListItemLabel,
  getCommonParamsItemLabel
} from '@/utils/common'
import store from '@/store'

export const contentTableConfig = {
  propList: [
    {
      prop: 'name',
      label: 'file.ota-name',
      width: 150
    },
    {
      prop: 'author',
      label: 'file.author',
      width: 150
    },
    {
      prop: 'company',
      label: 'file.company',
      width: 150
    },
    {
      prop: 'modelId',
      label: 'file.model-type',
      formatter: (row) => {
        return getGlobalParamsListItemLabel(row, 'terminalModel', {
          isNeedPreFix: false
        })
      }
    },
    {
      prop: 'tenantId',
      label: 'user.tenant',
      width: 180,
      formatter: (row) => {
        return row ? store.getters.tenantDataMap[row] : ''
      }
    },
    {
      prop: 'status',
      label: 'general.status',
      width: 120,
      formatter: (row) => {
        return getCommonParamsItemLabel(row, 'status')
      }
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time',
      width: 180
    },
    {
      prop: 'options',
      label: 'param.param-operation',
      width: 380,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true
}
